import { useRef } from "react";
import { useLocation } from "react-router-dom";
import VoucherTransactionListingPage from "./VoucherTransactionListingPage";
import VoucherVendorTransactions from "./VoucherVendorTransactions";

const VoucherTransactionListing = () => {
  const { state } = useLocation();
  const voucherContactsCacheRef = useRef(null);

  // L3: transactions for a specific customer + voucher vendor
  if (state?.company) {
    return <VoucherVendorTransactions />;
  }

  return (
    <VoucherTransactionListingPage
      key={state?.customerPhone || "__global__"}
      customerPhone={state?.customerPhone || null}
      customerName={state?.customerName || null}
      recentTransactions={state?.recentTransactions || null}
      voucherContactsCacheRef={voucherContactsCacheRef}
    />
  );
};

export default VoucherTransactionListing;
